import { DocumentGroup } from '../interfaces/DocumentGroup';

export default function getCurrentPeriod(documentGroups: DocumentGroup[]): string {
  if (documentGroups.length === 0) return null;

  const lastPeriod = documentGroups[0].period;
  const secondLast = (+lastPeriod - 1);

  return `${lastPeriod}-${secondLast}`;
}
